import constants from '@Common/Core/Constant';
import { BaseComponentAppearance, Component, ViewComponent } from '@InstanceFactory';

export namespace extensions {
    export function defineProperty(obj, name, getter, setter, enumerable = true) {
        Object.defineProperty(obj, name, {
            configurable: true,
            get: getter,
            set: setter,
            enumerable: enumerable
        });
    }

    export function appearanceGetter() {
        const self = this as Component;
        const view = this.$type === ViewComponent.typeName ? this : self.viewReference;
        const layoutId = view ? view.activeLayout.id : constants.guidEmpty;
        const apps = _.filter(self.appearances, app => app && app.viewLayout.id === layoutId);
        return apps[self.originalComponentTypeIndex];
    }

    export function appearanceSetter(value) {
        const self = this as Component;
        const view = this.$type === ViewComponent.typeName ? this : self.viewReference;
        const layoutId = view ? view.activeLayout.id : constants.guidEmpty;
        const searchFn = self.originalComponentTypeIndex ? _.findLastIndex : _.findIndex;
        const index = searchFn(self.appearances, app => {
            return app && app.viewLayout.id === layoutId;
        });
        if (index >= 0) {
            self.appearances[index] = value;
        }
    }

    export function appearanceWidthGetter() {
        const self = this as BaseComponentAppearance;
        return self.coordinates.x2 - self.coordinates.x1;
    }

    export function appearanceWidthSetter(value) {
        const self = this as BaseComponentAppearance;
        self.coordinates.x2 = self.coordinates.x1 + value;
    }

    export function appearanceHeightGetter() {
        const self = this as BaseComponentAppearance;
        return self.coordinates.y2 - self.coordinates.y1;
    }

    export function appearanceHeightSetter(value) {
        const self = this as BaseComponentAppearance;
        self.coordinates.y2 = self.coordinates.y1 + value;
    }

    export function appearanceTopGetter(this: BaseComponentAppearance) {
        return this.coordinates.y1;
    }

    export function appearanceTopSetter(this: BaseComponentAppearance, value) {
        const delta = this.coordinates.y1 - value;
        this.coordinates.y2 -= delta;
        this.coordinates.y1 = value;
    }

    export function appearanceLeftGetter(this: BaseComponentAppearance) {
        return this.coordinates.x1;
    }

    export function appearanceLeftSetter(this: BaseComponentAppearance, value) {
        const delta = this.coordinates.x1 - value;
        this.coordinates.x2 -= delta;
        this.coordinates.x1 = value;
    }
}
